import React, { createContext, useMemo, useState } from 'react';
import { ToastMessage } from '../types/toast';

export interface ToastContextValue {
  toastMessage?: ToastMessage; // setToastMessage 때마다 side-effect를 발생시키기 위해 object(non-primitive) 형식으로 만듦
  setToastMessage?: React.Dispatch<React.SetStateAction<ToastMessage | undefined>>;
}

const ToastContext = createContext<ToastContextValue>({});

export function ToastContextProvider({ children }: { children: React.ReactNode }) {
  const [toastMessage, setToastMessage] = useState<ToastContextValue['toastMessage']>(undefined);

  const value = useMemo<ToastContextValue>(
    () => ({
      toastMessage,
      setToastMessage,
    }),
    [toastMessage, setToastMessage]
  );

  return <ToastContext.Provider value={value}>{children}</ToastContext.Provider>;
}

export default ToastContext;
